"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapShades = void 0;
var _productBox = require("@ori/product-box");
const mapShades = ({
  data,
  productCode
}) => {
  const shades = (data?.product?.concept?.products ?? []).reduce((acc, product) => {
    if (product) {
      const {
        labels,
        shadeName
      } = product;
      const {
        productCode: shadeProductCode,
        hexColors,
        imageUrl
      } = (0, _productBox.mapShade)(product);
      acc.push({
        canBeSold: (0, _productBox.mapCanBeSold)(labels),
        hexColors,
        imageUrl,
        name: shadeName,
        productCode: shadeProductCode
      });
    }
    return acc;
  }, []);
  return {
    defaultCurrentShade: shades.find(shade => shade.productCode === productCode) ?? shades[0] ?? null,
    shades
  };
};
exports.mapShades = mapShades;
